module.exports = __webpack_public_path__ + "img/m_4.7918ad0d.png";